import { render, staticRenderFns } from "./AstrologyModel.vue?vue&type=template&id=4cecc590&"
import script from "./AstrologyModel.vue?vue&type=script&lang=js&"
export * from "./AstrologyModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports